import "./index.css";

import Container from "../Container";
import LogoSVG from "../Svg/LogoSVG";
import HeaderOptions from "./HeaderOptions";
import Image from "../Image";

interface HeaderProps {
  onClickHome?: () => void;
  onClickReel?: () => void;
  rightText?: string;
  leftImage?: string;
  rightTextStyle?: React.CSSProperties;
}

const Header = (props: HeaderProps) => {
  const {
    onClickHome,
    onClickReel,
    rightText = "EXPERIENCE THE NEXT",
    leftImage,
    rightTextStyle = {},
  } = props;

  return (
    <Container>
      <div className="base-header">
        <div style={{ width: "220px" }}>
          {leftImage ? <Image imagePath={leftImage} /> : <LogoSVG />}
        </div>
        <HeaderOptions onClickHome={onClickHome} onClickReel={onClickReel} />
        <div className="base-header-text-right" style={rightTextStyle}>
          {rightText}
        </div>
      </div>
    </Container>
  );
};

export default Header;
